var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17686 12C3.87168 12 3.57785 11.868 3.36289 11.6317L0.324934 8.29269C-0.115082 7.8091 -0.107194 7.03333 0.342436 6.56007C0.791819 6.08655 1.5131 6.09557 1.95336 6.57863L4.06421 8.89878L9.95056 0.48861C10.3289 -0.051724 11.0426 -0.160957 11.546 0.246547C12.0486 0.65352 12.1492 1.4216 11.771 1.9622L5.08696 11.5116C4.88729 11.7969 4.58187 11.9743 4.25032 11.9973C4.22591 11.9992 4.20151 12 4.17686 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.8ac68776e0fc91d9da9a3e1c79307c15.svg";
export { ForwardRef as ReactComponent };